import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const pulse = keyframes`
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
`;

export const ErrorWrapper = styled.div`
    width: 100%;
    height: 100%; 
    animation: ${fadeIn} 0.5s ease-out;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: ${({ theme }) => (theme.mode === 'dark'
    ? 'linear-gradient(135deg, rgba(220, 38, 38, 0.2) 0%, rgba(185, 28, 28, 0.25) 100%)'
    : 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#fca5a5' : '#dc2626')};
  animation: ${pulse} 2s ease-in-out infinite;
  box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 8px 24px rgba(220, 38, 38, 0.3)'
    : '0 8px 24px rgba(220, 38, 38, 0.15)')};

  svg {
    filter: ${({ theme }) => (theme.mode === 'dark'
    ? 'drop-shadow(0 2px 4px rgba(220, 38, 38, 0.4))'
    : 'drop-shadow(0 2px 4px rgba(220, 38, 38, 0.2))')};
  }
`;

export const ErrorTitle = styled.h2`
  font-size: 24px;
  font-weight: 400;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f1f5f9' : '#0f172a')};
  text-align: center;
  margin: 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const Code = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  background: ${({ theme }) => (theme.mode === 'dark'
    ? 'linear-gradient(135deg, rgba(51, 65, 85, 0.5) 0%, rgba(71, 85, 105, 0.5) 100%)'
    : 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#94a3b8' : '#64748b')};
  font-size: 13px;
  font-weight: 300;
  font-family: 'Courier New', monospace;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#475569' : '#cbd5e1')};
  letter-spacing: 0.5px;
  box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 2px 4px rgba(0, 0, 0, 0.3)'
    : '0 2px 4px rgba(0, 0, 0, 0.05)')};
`;

export const ErrorDescription = styled.p`
  font-size: 15px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#94a3b8' : '#64748b')};
  text-align: center;
  line-height: 1.6;
  max-width: 480px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 100%;
    padding: 0 16px;
  }
`;
